import { useLocalSearchParams } from 'expo-router'

import { WatchmanScreen, type TWatchmanSearchParams } from '@/src/features/watchman/ui/screens/WatchmanScreen'
import { filterSearchParams } from '@/src/general/utils/filterSearchParams'

export default () => {
  const searchParams = useLocalSearchParams()
  const { redirect, source, theme } = filterSearchParams<TWatchmanSearchParams>(searchParams)

  return <WatchmanScreen redirect={redirect} source={source} theme={theme} />
}
